import { Directive, HostListener, NgModule, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[ignoreWheelDirective]'
})
export class IgnoreWheelDirective implements OnDestroy{
  @HostListener('wheel', ['$event'])
  @HostListener('scroll', ['$event'])
  private destroy$ = new Subject<void>();
  onWheel(event: Event) {
    event.preventDefault();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}

@NgModule({
  declarations: [IgnoreWheelDirective],
  exports: [IgnoreWheelDirective],
})
export class IgnoreWheelDirectiveModule {}